const sortArrayByProperty = <T>(
  array: T[],
  property: keyof T,
  order: 'asc' | 'desc' = 'asc',
): T[] =>
  [...array].sort((a, b) => {
    const aValue = a[property];
    const bValue = b[property];

    if (aValue < bValue) {
      return order === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  });

export default sortArrayByProperty;
